import ApplicationController from "./application_controller"
import { vibrate } from "../helpers/vibrate_helpers"

/* This controller is used to perform vibrations on the device.
 * We use vibrateLight for eg. navigations, while vibrate is used for eg. button presses and toggles
 * The controller is meant to be mounted as a singleton on the body element.
 *
 * Usage:
 *  <a .. data-action="vibration#vibrateLight">Navigate</a>
 *  <button data-action="vibration#vibrate">Send message</button>
 */

export default class extends ApplicationController {
  vibrate () {
    vibrate(50)
  }

  vibrateLight () {
    vibrate(15)
  }
}
